//src/mock/gnerateMockNotification.ts
import {
    Notification,
    NotificationType,
    NotificationIconType,
    NotificationActionType,
    SeenState,
  } from "../gql/types";
  
  const notificationPool = [
    {
      type: NotificationType.GenericReminder,
      icon: NotificationIconType.Reminder,
      content: "Remember to complete your profile for better recommendations",
    },
    {
      type: NotificationType.GenericReminder,
      icon: NotificationIconType.ActionRequired,
      content: "Your account requires verification to unlock all features",
    },
    {
      type: NotificationType.GenericReminder,
      icon: NotificationIconType.Info,
      content: "We've updated our privacy policy, please review the changes",
    },
    {
      type: NotificationType.GenericReminder,
      icon: NotificationIconType.Reminder,
      content: "Your subscription will renew in 3 days",
    },
    {
      type: NotificationType.GenericReminder,
      icon: NotificationIconType.ActionRequired,
      content: "Security alert: New login detected from an unknown device",
    },
    {
      type: NotificationType.GenericReminder,
      icon: NotificationIconType.Info,
      content: "A new comment was added to your recent post",
    },
  ];
  
  export const generateMockNotification = (
    idIndex: number
  ): Notification => {
    const i = idIndex % notificationPool.length;
    const pool = notificationPool[i];
  
    return {
      __typename: "Notification",
      id: `notification-${idIndex}`,
      type: pool.type,
      icon: pool.icon,
      seenState: idIndex % 3 === 0 ? SeenState.Unseen : SeenState.Seen,
      createdAt: new Date(Date.now() - idIndex * 3600 * 1000 * 24).toISOString(), // i days ago
      content: {
        formattedText: pool.content,
        rawText: pool.content,
      },
      mainCTA: idIndex % 4 === 0
        ? {
            __typename: "NotificationCTA",
            actionType: NotificationActionType.OpenExternalUrl,
            label: "Take Action",
            url: "https://example.com/action",
          }
        : null,
      metadata: null,
    };
  };
  